import React, { memo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import './InformativoAssembleiasComImagem.scss';
import {
  ArrowRightIcon,
  Button,
  ButtonThemes,
} from 'plataforma-fundacao-componentes';
const rootClassName = 'informativo-assembleias-com-imagem';

interface InformativoAssembleiasComImagemProps {
  urlImg?: string;
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  onButtonClick?: (evt?: any) => void;
  reverse?: boolean;
  filledButton?: boolean;
  buttonMarginTop?: boolean;
}

function InformativoAssembleiasComImagem(
  props: InformativoAssembleiasComImagemProps
) {
  return (
    <div
      className={clsx([
        rootClassName,
        props.reverse ? 'reverse' : '',
        props.filledButton ? 'wrap' : 'wrap-reverse',
      ])}
    >
      <div className={`${rootClassName}-text`}>
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <p className={`${rootClassName}-sub-title nunito`}>{props.subtitle}</p>
        <div
          className={clsx([
            `${rootClassName}-button`,
            props.filledButton ? 'filled' : '',
          ])}
        >
          <Button
            theme={
              props.filledButton
                ? ButtonThemes.Primary
                : ButtonThemes.DefaultPrimary
            }
            onClick={props.onButtonClick}
            rightIcon={props.filledButton ? undefined : <ArrowRightIcon />}
            style={props.buttonMarginTop ? { marginTop: '14px' } : {}}
          >
            {props.buttonLabel}
          </Button>
        </div>
      </div>
      <div
        className={`${rootClassName}-photo`}
        style={{ backgroundImage: `url(${props.urlImg})` }}
      >
        <img alt='img' src={props.urlImg} />
      </div>
    </div>
  );
}

export default memo(InformativoAssembleiasComImagem);
